<div id="top" class="w-100 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Exporter l'état de la facturation</div>
</div>

<div class="w-100 ml-3 mt-3">
    @if (missionReports && missionReports.reports.length > 0) {
        <div>
            @for (report of missionReports.reports; track report) {
                <p class="report {{ brand }}">
                    Télécharger :
                    <span class="report-link" (click)="downloadReportHandler(report.file_id, report.report_name)">{{ report.report_name }}</span>
                </p>
            }
        </div>
    }

    @if (message && missionReports.reports.length === 0) {
        <div>
            <p class="report {{ brand }}">Aucun rapport n'a pu être généré.</p>
        </div>
    }

    @if (missionReports && missionReports.reports.length > 0) {
        <hr/>
    }

    @if (reportsForm) {
        <form [formGroup]="reportsForm" (submit)="save()">
            <section>
                <h3>Choisissez une période mensuelle (Minimum: 03/{{ currentYear }})</h3>
                <div class="period">
                    <input type="text" formControlName="period" placeholder="04/{{ currentYear }}"/>
                </div>
                @if (reportsFormSubmitted && reportsForm.controls.period.errors) {
                    <div class="form-text error-message">{{ getError('period') }}</div>
                }
                @if (invalidPeriod) {
                    <div class="form-text error-message">La periode est invalide.</div>
                }
            </section>
            <hr/>
            <section>
                <label for="billingStatus" class="box-grid">
                    <input type="checkbox" id="billingStatus" value="on" formControlName="billingStatus"/>
                    <h3>Synthèse globale des lignes</h3>
                </label>
                <div class="export-bill">
                    <p class="option">Souhaitez-vous inclure les consommations ?</p>
                    <div>
                        <input id="inputYes" name="option" type="radio" value="false" (click)="optionHandler($event)"
                               checked/>
                        <label for="inputYes">Oui</label>
                    </div>
                    <div>
                        <input id="inputNo" name="option" type="radio" value="true" (click)="optionHandler($event)"/>
                        <label for="inputNo">Non</label>
                    </div>
                </div>
            </section>
            <hr/>
            <section>
                <label for="communicationDetails" class="box-grid">
                    <input type="checkbox" id="communicationDetails" formControlName="communicationDetails"/>
                    <h3>Synthèse détaillée des consommations effectuées</h3>
                </label>
                @if (reportsFormSubmitted && communicationDetailsReport) {
                    <div class="form-text error-message">Ce rapport a déjà été généré.</div>
                }
            </section>
            <hr/>
            <section>
                <label for="billingAnalysis" class="box-grid">
                    <input type="checkbox" id="billingAnalysis" formControlName="billingAnalysis"/>
                    <h3>Synthèse complète des montants et volumes appels/data/sms</h3>
                </label>
                @if (reportsFormSubmitted && billingAnalysisReport) {
                    <div class="form-text error-message">Ce rapport a déjà été généré.</div>
                }
            </section>
            @if (showError) {
                <p class="error-message">Vous devez choisir au moins un type de rapport.</p>
            }
            <hr/>
            <div class="col-12 w-100 cta_container pt-3 text-center">
                <button type="button" class="cta_cancel column" (click)="cancel()">Fermer<span></span></button>
                <button type="submit" class="cta_btn level_2 column">Valider<span></span></button>
            </div>
        </form>
    }
</div>
